const professions = [
  "Doctor",
  "Engineer",
  "Teacher",
  "Professor",
  "Lawyer",
  "Businessperson",
  "Government Employee",
  "Police Officer",
  "Armed Forces",
  "Farmer",
  "Driver",
  "Nurse",
  "Accountant",
  "Architect",
  "Artist",
  "Scientist",
  "Banker",
  "Chef",
  "Clerk",
  "Homemaker",
  "Retired",
  "Unemployed",
  "Other"
];

const occupationInput = ({formData, handleInputChange, parent}) => {
    return (
        <div className="form-group">
          <label htmlFor={`${parent}Occupation`} style={{textTransform: 'capitalize'}}>{parent}'s Occupation *</label>
          <input
            type="text"
            id={`${parent}Occupation`}
            name={`${parent}Occupation`}
            value={formData[`${parent}Occupation`] || ""}
            onChange={handleInputChange}
            required
            placeholder={`Enter ${parent}'s occupation`}
            list={`${parent}OccupationList`}
          />
          <datalist id={`${parent}OccupationList`}>
          {professions.map((profession, index) => (
              <option key={index} value={profession} />
          ))}
          </datalist>
        </div>
    );
}

export default occupationInput;